<template>
    <CCardBody style="background-color: #F5F5F5;">
        
        <CRow>
            <CButton
                size="sm"
                class="btn-class mb-1"
                @click="editarInfoUsuario">
                Editar Información
            </CButton>
        </CRow>
        <CRow>
            <CCol>
                <div>
                    <span class="font-weight-bold">Usuario Habilitado: </span>
                    <CIcon style="color:green" name="cil-check-circle" v-show="informacionUsuario.habilitado"/>
                    <CIcon style="color:red" name="cil-x-circle" v-show="!informacionUsuario.habilitado" />
                </div>
                <div><span class="font-weight-bold">Usuario Vapp: </span> {{ informacionUsuario.username }}</div>
                <div><span class="font-weight-bold">Nombre: </span> {{ informacionUsuario.nombreUsuario }} {{  informacionUsuario.apellidoPat}} {{ informacionUsuario.apellidoMat }}</div>
                <div>
                    <span class="font-weight-bold">Mail: </span>
                    <span v-show="!editarInfo"> {{ informacionUsuario.mailUsuario }} (se puede editar)</span>
                </div>
                <div>
                    <span class="font-weight-bold">Tipo Usuario: </span> 
                    <span v-show="!editarInfo">
                        {{ informacionUsuario.usuarioAdmin ? 'Admin' : 'Normal' }} (se puede editar)
                    </span>
                </div>
                <div>
                    <span class="font-weight-bold">Creado: </span> 
                    <span>
                        {{ $utils.formatearFecha(informacionUsuario.fechaCreacionUsuario) }} 
                    </span>
                </div>
                <div><span class="font-weight-bold">Expira: </span> 
                    <span v-show="!editarInfo">
                        {{ $utils.formatearFecha(informacionUsuario.fechaExpiracionUsuario) }} (se puede editar)
                    </span>
                </div>
            </CCol>
        </CRow>
        {{ informacionUsuario }}
    </CCardBody>
</template>


<script>
    import Vue from 'vue'
    import cons from "@/const";
    import axios from "axios";

    import Multiselect from "vue-multiselect";

    import VueModal from "@kouts/vue-modal";
    import "@kouts/vue-modal/dist/vue-modal.css";

    import { freeSet } from "@coreui/icons";

    //import moment from 'moment'
    import { format, formatDistance, formatRelative, isThisISOWeek, subDays } from "date-fns";
    import es from "date-fns/locale/es";
    window.locale = "es";

    

    //import DatePicker from 'vue2-datepicker';
    //import 'vue2-datepicker/index.css';

    import Pagination from 'vue-pagination-2';

    export default {
        name: "InfoUsuario",
        freeSet,
        props: {
            informacionUsuario: Object,
        },
        components: {
            Multiselect,
            Modal: VueModal,
            Pagination,
        },
        data() {
            return {

                baseUrl: cons.protocolo + "://" + cons.ipServer + cons.puerto,

                tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,

                editarInfo: false,
            };
        },
        created: function () {},
        beforeMount() {
        },
        mounted() {},
        methods: {
            editarInfoUsuario: function(){
                this.editarInfo = !this.editarInfo
            }


        },
    };
</script>

<style>

.cardHabil{
    border-color: green;
}
.cardDeshab{
    border-color: red;
}

</style>